import { isClient } from "../uikit.helpers/client.es.js";
import { defineStore } from "pinia";
const useScreenSizeStore = defineStore("uikit-screen-size", {
  state: () => ({
    windowWidth: isClient() ? window.innerWidth : 1e3
  }),
  getters: {
    // Mobile-landscape (and larger)
    isMinMobileWidth: (state) => state.windowWidth >= 576,
    isOnlyMobileLandscapeWidth: (state) => state.windowWidth >= 576 && state.windowWidth < 768,
    isMaxMobileLandscapeWidth: (state) => state.windowWidth < 768,
    // Tablet-portrait (and larger)
    isMinTabletPortraitWidth: (state) => state.windowWidth >= 768,
    isOnlyTabletPortraitWidth: (state) => state.windowWidth >= 768 && state.windowWidth < 1024,
    isMaxTabletPortraitWidth: (state) => state.windowWidth < 1024,
    // Tablet-landscape (and larger)
    isMinTabletLandscapeWidth: (state) => state.windowWidth >= 1024,
    isOnlyTabletLandscapeWidth: (state) => state.windowWidth >= 1024 && state.windowWidth < 1200,
    // Laptops (and larger)
    isLaptopWidth: (state) => state.windowWidth > 1200,
    isLaptopXLWidth: (state) => state.windowWidth > 1700,
    isLaptopXLLWidth: (state) => state.windowWidth > 1700,
    // OLD IS MOBILE
    // Small Mobile-landscape (and larger)
    isMobileWidth: (state) => state.windowWidth < 576
  },
  actions: {
    startWatching() {
      this.setWindowInnerWidth();
      const self = this;
      window.addEventListener("resize", () => {
        self.setWindowInnerWidth();
      });
    },
    setWindowInnerWidth() {
      this.windowWidth = window.innerWidth;
    }
  }
});
export {
  useScreenSizeStore
};
//# sourceMappingURL=screenSize.es.js.map
